import styled, { css } from 'styled-components'
import { BP } from 'resources/constants'

export const sectionCss = css`
  margin: 0 auto;
  max-width: ${BP.max};
  padding: 30px 0;

  @media (min-width: ${BP.sm.min}) {
    padding-top: 30px;
    padding-bottom: 40px;
  }

  @media (min-width: ${BP.md.min}) {
    padding-top: 40px;
    padding-bottom: 50px;
  }

  @media (min-width: ${BP.lg.min}) {
    padding-top: 50px;
    padding-bottom: 60px;
  }
`

export const Section = styled.section<any>`
  ${sectionCss}
`
